import { render, staticRenderFns } from "./FeedbackModalDialog.vue?vue&type=template&id=72ba970b"
import script from "./FeedbackModalDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackModalDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports